export default function TikTok({ size = 18, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M16.6 5.82a4.28 4.28 0 0 1-1.05-2.82h-3.2v12.66a2.5 2.5 0 1 1-2.5-2.5c.26 0 .5.04.74.11V9.99a5.7 5.7 0 0 0-.74-.05 5.7 5.7 0 1 0 5.7 5.7V9.01a7.42 7.42 0 0 0 4.35 1.4V7.2a4.28 4.28 0 0 1-3.3-1.38z" />
    </svg>
  );
}
